(() => {
  const initialize = (section) => {
    if (!section || section.dataset.productShopTheLookInitialized === 'true') return;

    const track = section.querySelector('[data-product-shop-the-look-track]');
    const previousButton = section.querySelector('[data-product-shop-the-look-prev]');
    const nextButton = section.querySelector('[data-product-shop-the-look-next]');
    if (!track || !previousButton || !nextButton) return;

    section.dataset.productShopTheLookInitialized = 'true';

    const updateControls = () => {
      const maxScroll = track.scrollWidth - track.clientWidth - 1;
      previousButton.disabled = maxScroll <= 0 || track.scrollLeft <= 1;
      nextButton.disabled = maxScroll <= 0 || track.scrollLeft >= maxScroll;
    };

    const getScrollAmount = () => {
      const firstCard = track.querySelector('.product-card');
      if (!firstCard) return track.clientWidth;

      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    previousButton.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    window.requestAnimationFrame(updateControls);
  };

  document.querySelectorAll('[data-product-shop-the-look]').forEach(initialize);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.('[data-product-shop-the-look]')
      ? event.target
      : event.target.querySelector?.('[data-product-shop-the-look]');
    initialize(section);
  });
})();
